var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('configurator',{ref:"configurator",attrs:{"p_configuratorSettings":_vm.configuratorSettings,"p_configuratorName":_vm.p_configuratorName,"p_configuratorId":_vm.p_configuratorId,"p_configuratorDomain":_vm.p_configuratorDomain,"p_logoUrl":_vm.logoUrl,"p_randomFacts":_vm.randomFactsString}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-595df760","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/configurator/ConfiguratorView.vue
// module id = null
// module chunks = 